import { render, staticRenderFns } from "./SwitchWrapper.vue?vue&type=template&id=2d0fe970&"
import script from "./SwitchWrapper.vue?vue&type=script&lang=js&"
export * from "./SwitchWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Applications/MAMP/happoproperty.jp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d0fe970')) {
      api.createRecord('2d0fe970', component.options)
    } else {
      api.reload('2d0fe970', component.options)
    }
    module.hot.accept("./SwitchWrapper.vue?vue&type=template&id=2d0fe970&", function () {
      api.rerender('2d0fe970', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/core/components/SwitchWrapper.vue"
export default component.exports